module.exports = __webpack_public_path__ + "static/cateau0-aca2c4ebc48f4dd8b8854a232ce4e1dd.webp";